import RecoverPassword from './styled';

export default RecoverPassword;
